module.exports = __webpack_public_path__ + "media/waves1920.316cf2f7.mp4";